import { Navigate, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/supply/blocked-list/')({
  component: BlockedListIndexRoute,
});

function BlockedListIndexRoute() {
  return <Navigate to="/supply/blocked-list/creatives" replace />;
}
